import(/* webpackMode: "eager", webpackExports: ["NotFoundBoundary"] */ "/vercel/path0/frontend/components/not-found/not-found-boundary.tsx");
